import { gql } from '@apollo/client';

const racewayViewItem = gql`
  fragment RacewayViewItem on RacewayView {
    id
    hasLinks
    hasPackages
    hasNotes
    hasRacewayWrap
    racewayType
  }
`;

export const racewayFragments = {
  racewayItem: gql`
    ${racewayViewItem}
    fragment RacewayItem on Raceway {
      id
      projectId
      tag
      racewayView {
        ...RacewayViewItem
      }
      primaryStatus
      engineeringStatus
      secondaryStatus
      constructionStatus
      cardRev
      engrLength
      actualLength
      drawing
      drawing2
      calcDrawing
      disciplineCode
      safetyCode
      revision
      unit
      facility
      room
      addlWeightPerUnit
      maxWeigthPerUnit
      reservedWidth
      numberOfCovers
      isUnderground
      ductBankTag
      latitude
      longitude
      elevation
      totalNoOfCables
      installedNoOfCables
      totalPctFill
      installedPctFill
      totalAvailPctFill
      installedAvailPctFill
      totalAvailSpace
      installedAvailSpace
      totalOverfillFlag
      installedOverfillFlag
      totalWeightPerUnit
      installedWeightPerUnit
      totalOverweightFlag
      installedOverweightFlag
      numberOfFittings
      installedNoOfSupports
      installedTime
      installedBy
      inspectedTime
      inspectedBy
      misc1
      misc2
      misc3
      misc4
      misc5
      misc6
      misc7
      misc8
      misc9
      misc10
      misc11
      misc12
      misc13
      misc14
      misc15
      misc16
      misc17
      misc18
      misc19
      misc20
      miscDate1
      miscDate2
      isBarriered
      isRecalcRequired
      ownerId
      ownerTag
      preparedTime
      preparedBy
      updatedByUser {
        id
        nameFirst
        nameLast
        nameMiddle
        userAccountPhoto {
          id
          photo
        }
      }
      checkedTime
      checkedBy
      approvedTime
      approvedBy
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      updatedTime
      updatedBy
      racewayCodeId
      racewayCode {
        id
        tag
      }
      serviceLevelId
      addlServiceLevelId
      startupSystemId
      startupSystem {
        id
        tag
      }
      serviceLevel {
        id
        name
      }
      addlServiceLevel {
        id
        name
      }
      isRestricted
      separationGroupId
      separationGroup {
        id
        name
      }
    }
  `,
  feedbackRacewayItem: gql`
    fragment FeedbackRacewayFields on Raceway {
      id
      actualLength
      constructionStatus
      numberOfFittings
      installedNoOfSupports
      installedTime
      installedBy
      inspectedTime
      inspectedBy
      tag
      engrLength
      updatedBy
      updatedTime
      updatedByUser {
        nameFirst
        nameLast
        nameMiddle
        userAccountPhoto {
          id
          photo
        }
      }
      serviceLevelId
      serviceLevel {
        name
      }
    }
  `,
  racewayBarrierItem: gql`
    fragment RacewayBarrierItem on RacewayBarrier {
      id
      totalNoOfCables
      totalAvailSpace
      totalAvailPctFill
      totalPctFill
      reservedWidth
      secondaryStatus
      racewayCode {
        tag
        id
      }
      serviceLevel {
        id
        name
      }
      installedNoOfCables
      installedPctFill
      installedAvailPctFill
      installedAvailSpace
      installedOverfillFlag
      totalOverfillFlag
    }
  `,
};

export const GET_RACEWAY_BY_ID = gql`
  ${racewayFragments.racewayItem}
  query RacewayById($id: ID!) {
    racewayById(id: $id) {
      ...RacewayItem
    }
  }
`;

export const SEARCH_RACEWAY = gql`
  ${racewayFragments.feedbackRacewayItem}
  query Query($searchInput: SearchInput) {
    searchRaceways(searchInput: $searchInput) {
      items {
        ...FeedbackRacewayFields
      }
    }
  }
`;

export const FEEDBACK_RACEWAY = gql`
  ${racewayFragments.feedbackRacewayItem}
  mutation FeedbackRaceway($feedbackRacewayInput: FeedbackRacewayInput!) {
    feedbackRaceway(feedbackRacewayInput: $feedbackRacewayInput) {
      raceway {
        ...FeedbackRacewayFields
      }
      errors
    }
  }
`;

export const CREATE_RACEWAY = gql`
  ${racewayFragments.racewayItem}
  mutation CreateRaceway($createRacewayInput: CreateRacewayInput!) {
    createRaceway(createRacewayInput: $createRacewayInput) {
      raceway {
        ...RacewayItem
      }
      errors
    }
  }
`;

export const UPDATE_RACEWAY = gql`
  ${racewayFragments.racewayItem}
  mutation UpdateRaceway($updateRacewayInput: UpdateRacewayInput!) {
    updateRaceway(updateRacewayInput: $updateRacewayInput) {
      errors
      infos
      raceway {
        ...RacewayItem
      }
    }
  }
`;

export const UPDATE_RACEWAYS = gql`
  ${racewayFragments.racewayItem}
  mutation UpdateRaceways($updateRacewaysInput: [UpdateRacewayInput!]!) {
    updateRaceways(updateRacewaysInput: $updateRacewaysInput) {
      raceways {
        ...RacewayItem
      }
      infos {
        tag
        messageKeys
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const DELETE_RACEWAY = gql`
  mutation DeleteRaceway($deleteRacewayInput: DeleteRacewayInput!) {
    deleteRaceway(deleteRacewayInput: $deleteRacewayInput) {
      id
      errors
      infos
    }
  }
`;

export const SEARCH_RACEWAY_BARRIERS = gql`
  ${racewayFragments.racewayBarrierItem}
  query SearchRacewayBarriers($searchInput: SearchInput) {
    searchRacewayBarriers(searchInput: $searchInput) {
      items {
        ...RacewayBarrierItem
      }
    }
  }
`;

export const SAVE_RACEWAY_BARRIERS = gql`
  ${racewayFragments.racewayBarrierItem}
  mutation SaveRacewayBarriers($saveRacewayBarriersInput: SaveRacewayBarriersInput!) {
    saveRacewayBarriers(saveRacewayBarriersInput: $saveRacewayBarriersInput) {
      errors
      racewayBarriers {
        ...RacewayBarrierItem
      }
    }
  }
`;

export const GET_RACEWAY_BY_IDS = gql`
  ${racewayFragments.racewayItem}
  query RacewayByIds($ids: [ID!]!) {
    racewayByIds(ids: $ids) {
      ...RacewayItem
    }
  }
`;

export const ISSUE_RACEWAYS = gql`
  ${racewayFragments.racewayItem}
  mutation IssueRaceways($issueRacewaysInput: [IssueRacewayInput!]!) {
    issueRaceways(issueRacewaysInput: $issueRacewaysInput) {
      raceways {
        ...RacewayItem
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const SEARCH_RACEWAY_WRAPS = gql`
  query SearchRacewayWraps($searchInput: SearchInput) {
    searchRacewayWraps(searchInput: $searchInput) {
      items {
        id
        wrapCode
        zoneName
        zoneLength
      }
    }
  }
`;

export const SAVE_RACEWAY_WRAPS = gql`
  mutation SaveRacewayWrap($saveRacewayWrapInput: SaveRacewayWrapInput!) {
    saveRacewayWrap(saveRacewayWrapInput: $saveRacewayWrapInput) {
      racewayWraps {
        id
        wrapCode
        zoneName
        zoneLength
      }
      errors
      infos
    }
  }
`;

export const GET_RACEWAY_STATS = gql`
  query RacewayStats($racewayStatsInput: RacewayStatsInput) {
    racewayStats(racewayStatsInput: $racewayStatsInput) {
      totalCount
      withoutCablesCount
      revisedCardCount
      onHoldCount
      preliminaryCount
      releasedCount
      jobsiteCount
      constructedCount
      underGroundCount
      aboveGroundCount
    }
  }
`;

export const GET_RACEWAY_VIEW_STATS = gql`
  ${racewayViewItem}
  query GetRacewayViewStats($id: ID!) {
    racewayById(id: $id) {
      id
      totalNoOfCables
      isBarriered
      racewayView {
        ...RacewayViewItem
      }
    }
  }
`;

export const AUTHORIZE_FILL = gql`
  ${racewayFragments.racewayItem}
  mutation Mutation($authorizeFillInput: AuthorizeFillInput!) {
    authorizeFill(authorizeFillInput: $authorizeFillInput) {
      errors
      raceway {
        ...RacewayItem
      }
    }
  }
`;
